import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=8ab83f5a&"
import script from "./SelectBox.vue?vue&type=script&lang=ts&"
export * from "./SelectBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports